<content>

    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm">
            <div *ngIf="filtersForm.get('pais')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'global.pais' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="paises" 
                    (shareCheckedList)="shareCheckedListPaises($event)"
                    [selectedItem]="filtersForm.get('pais')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('denominacion')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'central-avisos.designaciones.innerFilters.denominacion' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="denominaciones" 
                    (shareCheckedList)="shareCheckedListDenominaciones($event)"
                    [selectedItem]="filtersForm.get('denominacion')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('finca')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'global.finca' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="fincas" 
                    (shareCheckedList)="shareCheckedListFincas($event)"
                    [selectedItem]="filtersForm.get('finca')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('productor')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'central-avisos.designaciones.innerFilters.productor' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="productores" 
                    (shareCheckedList)="shareCheckedListProductores($event)"
                    [selectedItem]="filtersForm.get('productor')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('etiquetador')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'central-avisos.designaciones.innerFilters.etiquetador' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="etiquetadores" 
                    (shareCheckedList)="shareCheckedListEtiquetadores($event)"
                    [selectedItem]="filtersForm.get('etiquetador')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            
            <div *ngIf="filtersForm.get('porcentajeEtiquetado')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'global.porcentajeConfeccionado' | translate}} ></label>
                <input type="number" formControlName="porcentajeEtiquetado">
            </div>
            <div *ngIf="filtersForm.get('bloqueoDesde')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'central-avisos.designaciones.innerFilters.bloqueoDesde' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="bloqueoDesde"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div *ngIf="filtersForm.get('bloqueoHasta')" [ngClass]="isSmallScreen ? 'entry-' + entryForm + '-small' : 'entry-' + entryForm">
                <label>{{'central-avisos.designaciones.innerFilters.bloqueoHasta' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="bloqueoHasta"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.filtrar' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible}" (click)="filtersForm.reset()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.aplicar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>

    <div *ngIf="showExpedicionCero" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.designaciones.expedicionCero.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="campanyaFechaInicio" data-type="date" (click)="toOrderBy(3)">
                        {{'central-avisos.designaciones.expedicionCero.inicioCampanya' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(4)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(5)">
                        {{'central-avisos.designaciones.expedicionCero.productor' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(6)">
                        {{'central-avisos.designaciones.expedicionCero.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="fechaPrimerConsumo" data-type="date" (click)="toOrderBy(7)">
                        {{'central-avisos.designaciones.expedicionCero.primerConsumo' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(7)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="numDiasSinImprimir" (click)="toOrderBy(8)">
                        {{'central-avisos.designaciones.expedicionCero.diasSinConfeccionar' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(8)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let data of dataExpedicionCeroDiasDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string td-padding">{{data.desPais}}</td>
                    <td class="string">{{data.desDenominacion}}</td>
                    <td class="date">{{data.campanyaFechaInicio | date:"shortDate" : undefined : defaultLanguage}}</td>
                    <td class="string-longest">{{data.desFinca}}</td>
                    <td class="string-longest">{{data.desProductor}}</td>
                    <td class="string-longest">{{data.desEtiquetador}}</td>
                    <td class="date">{{data.fechaPrimerConsumo | date:"short" : undefined : defaultLanguage}}</td>
                    <td class="string">{{data.numDiasSinImprimir ? data.numDiasSinImprimir : 'central-avisos.designaciones.expedicionCero.sinConsumos' | translate}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataExpedicionCeroDiasDisplayed || (dataExpedicionCeroDiasDisplayed && dataExpedicionCeroDiasDisplayed.length < 1)">
                <tr>
                  <td colspan="8">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showExpedicionDesignados" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.designaciones.expedicionDesignados.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(3)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(4)">
                        {{'central-avisos.designaciones.expedicionDesignados.productor' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(5)">
                        {{'central-avisos.designaciones.expedicionDesignados.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="kilosImpresosEfectivos" (click)="toOrderBy(6)">
                        {{'global.confeccionadoKg' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="porcentaje" (click)="toOrderBy(7)">
                        {{'global.porcentajeConfeccionado' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(7)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desFinca}}</td>
                    <td class="string-longest">{{row.desProductor}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="number-longest td-padding">{{row.kilosImpresosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number">{{row.porcentaje | number : '1.2-2': defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="7">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showDesignadosAforo" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.designaciones.designadosAforo.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(3)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(4)">
                        {{'central-avisos.designaciones.designadosAforo.productor' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(5)">
                        {{'central-avisos.designaciones.designadosAforo.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="sumCantidad" (click)="toOrderBy(6)">
                        {{'central-avisos.designaciones.designadosAforo.designados' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="aforo" (click)="toOrderBy(7)">
                        {{'central-avisos.designaciones.designadosAforo.aforo' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(7)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="porcentaje" (click)="toOrderBy(8)">
                        {{'central-avisos.designaciones.designadosAforo.porcentaje' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(8)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desFinca}}</td>
                    <td class="string-longest">{{row.desProductor}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="number-longest">{{row.sumCantidad | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number-longest">{{row.aforo | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number">{{row.porcentaje | number : '1.2-2': defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="8">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showDesignacionesDeshabilitadas" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.designaciones.designacionesDeshabilitadas.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(3)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(4)">
                        {{'central-avisos.designaciones.designacionesDeshabilitadas.productor' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(5)">
                        {{'central-avisos.designaciones.designacionesDeshabilitadas.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="fechaImpresionDesautorizada" data-type="date" (click)="toOrderBy(6)">
                        {{'central-avisos.designaciones.designacionesDeshabilitadas.fechaBloqueo' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desFinca}}</td>
                    <td class="string-longest">{{row.desProductor}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="date">{{row.fechaImpresionDesautorizada | date:"short" : undefined : defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="6">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showDesignacionesFinalizadas" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.designaciones.designacionesFinalizadas.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(3)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(4)">
                        {{'central-avisos.designaciones.designacionesFinalizadas.productor' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(5)">
                        {{'central-avisos.designaciones.designacionesFinalizadas.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="fechaFinalizada" data-type="date" (click)="toOrderBy(6)">
                        {{'central-avisos.designaciones.designacionesFinalizadas.fechafinalizacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desFinca}}</td>
                    <td class="string-longest">{{row.desProductor}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="date">{{row.fechaFinalizada | date:"short" : undefined : defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="6">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>

    <app-paginator
        *ngIf="(dataDisplayed && dataDisplayed.length > 0) || (dataExpedicionCeroDiasDisplayed && dataExpedicionCeroDiasDisplayed.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"
        [ngStyle]="{'margin-top': totalItems <= itemsPerPage ? '1em' : ''}"></app-paginator>
</content>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
